module.exports = __webpack_public_path__ + "static/media/circumference_cat_english.2eed383b.png";